import React from 'react';
import { Plus, Eye, Edit, Trash2, Copy, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link, useNavigate } from 'react-router-dom';
export function ManageCourses() {
  const navigate = useNavigate();
  const courses = [{
    pos: 1,
    courseNo: 'CD17355',
    name: 'Ethics & The Rules (with NAR Code of Ethics)',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 2,
    courseNo: 'None',
    name: 'NAR Code of Ethics (NO CE CREDIT)',
    sections: 5,
    questions: 27,
    passing: 80,
    price: '$14.95  (N)',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 3,
    courseNo: 'FWD17590',
    name: 'Deeds, Fires & Water: Be Prepared',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 5,
    courseNo: 'CD16995',
    name: 'Are They Represented?',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 6,
    courseNo: 'CD18311',
    name: 'Mastering Agency Agreements',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 8,
    courseNo: 'CD16991',
    name: 'A Letter From ADRE',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 9,
    courseNo: 'CD17085',
    name: "Don't Lose Your License",
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 10,
    courseNo: 'CD17707',
    name: 'BMC #1 AZ Residential-Statutes and Rules',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 11,
    courseNo: 'CD17708',
    name: 'BMC #2 AZ Residential-Broker Policies',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 12,
    courseNo: 'CD17709',
    name: 'BMC #3 AZ Residential-Broker Supervision',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 13,
    courseNo: 'CD18092',
    name: 'BMC #3B Property Management',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 14,
    courseNo: 'CD16990',
    name: 'What Goes Wrong In Contracts',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 15,
    courseNo: 'CD18093',
    name: 'Avoid The Oops: Contract Smarts for Agents',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 17,
    courseNo: 'CD16992',
    name: 'No Secrets',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 18,
    courseNo: 'CD18149',
    name: 'The Bottom Line of Disclosure',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 19,
    courseNo: 'CE15753',
    name: 'Your Clients Are Not Mushrooms',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 20,
    courseNo: 'CD16993',
    name: 'They Are A Protected Class',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 21,
    courseNo: 'CD15797',
    name: "Fair Housing In Today's World",
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: 'They Are A Protected Class'
  }, {
    pos: 23,
    courseNo: 'CE17700',
    name: 'Accidental Property Management',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 24,
    courseNo: 'CD16994',
    name: 'Follow All The Laws',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }];
  return <div className="space-y-6" data-id="element-1200" data-mp="28mltkopgbox">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1201" data-mp="27l632wqv10v">Manage Courses</h1>

      <div className="mb-4" data-id="element-1202" data-mp="1mr6s8t3v1usm">
        <Button variant="secondary" size="sm" className="gap-2 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm hover:from-slate-50 hover:to-slate-200" onClick={() => navigate('/courses/add')} data-id="element-1203" data-mp="1mqf7kdbsxhh4">
          <Plus className="h-4 w-4 text-green-600" data-id="element-1204" data-mp="18yh86u7w6zy5" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1205" data-mp="141ibq50ragws">
        <div className="overflow-x-auto" data-id="element-1206" data-mp="z1m7c4o5cngp">
          <table className="w-full text-sm text-left" data-id="element-1207" data-mp="yzszim1srx74">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1208" data-mp="uzhev99fpwvn">
              <tr data-id="element-1209" data-mp="v1vbvnnodj5u">
                <th className="px-2 py-3 border-r border-slate-700 text-center w-16" data-id="element-1210" data-mp="q0o4vqtcwo08">
                  Position
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-24" data-id="element-1211" data-mp="2pcqt1ecxe6k8">
                  Course No
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center" data-id="element-1212" data-mp="2kf8i5ifclh9l">
                  Name
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-16" data-id="element-1213" data-mp="33hhe3i6dia1u">
                  Sections
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-1214" data-mp="2uj5nhg5ibc9e">
                  Questions
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-1215" data-mp="2zi8j69zlk64p">
                  Passing(%)
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1216" data-mp="3r8wjxkxcz9hu">
                  Price
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-1217" data-mp="3d9ww2fho6ymq">
                  Published
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-32" data-id="element-1218" data-mp="3i6ndb657o09q">
                  Renewed To
                </th>
                <th className="px-4 py-3 text-center w-44" data-id="element-1219" data-mp="26t1o5kzcpyo7">
                  <div data-id="element-1220" data-mp="26umf70mgizhb">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1221" data-mp="1z9ik3quuv4n4">
                    View | Edit | Delete | Clone | Renew
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1222" data-mp="28aqjydd0sdjb">
              {courses.map(course => <tr key={course.pos} className="hover:bg-slate-50" data-id="element-1223" data-mp="23am2ol4afes1">
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1224" data-mp="239ayik6xk50e">
                    {course.pos}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200" data-id="element-1225" data-mp="1bkr0hnvbzuly">
                    {course.courseNo}
                  </td>
                  <td className="px-4 py-3 border-r border-slate-200" data-id="element-1226" data-mp="1pcxfh6mqzvjt">
                    {course.name}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1227" data-mp="1kit66gq0fbfk">
                    <button className="text-blue-600 hover:underline" onClick={() => navigate(`/courses/${course.pos}/sections`)} data-id="element-1228" data-mp="wsywg80zm2zj">
                      {course.sections}
                    </button>
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1229" data-mp="gb376jz6sm00">
                    {course.questions}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1230" data-mp="lbhiqbzzye2s">
                    {course.passing}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200" data-id="element-1231" data-mp="ual11drcapg8">
                    {course.price}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-1232" data-mp="z11h75mjop6a">
                    {course.published}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200 text-slate-700" data-id="element-1233" data-mp="142ifctdn9xj6">
                    {course.renewedTo}
                  </td>
                  <td className="px-4 py-3 text-center" data-id="element-1234" data-mp="1dxsi5jbva8y0">
                    <div className="flex items-center justify-center gap-2" data-id="element-1235" data-mp="1dwhb9an4kl2o">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/courses/view/${course.pos}`)} data-id="element-1236" data-mp="2yi7bgblutu8f">
                        <Eye className="h-4 w-4" data-id="element-1237" data-mp="2jjlqqmwzyoe7" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/courses/edit/${course.pos}`)} data-id="element-1238" data-mp="2jlq0vmlhojmx">
                        <Edit className="h-4 w-4" data-id="element-1239" data-mp="37g9cgr5l8mvp" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1240" data-mp="32ir87e2imvu1">
                        <Trash2 className="h-4 w-4" data-id="element-1241" data-mp="3u25hvm4iz68" />
                      </button>
                      <button title="Clone" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-1242" data-mp="3v4si0yx96lk3">
                        <Copy className="h-4 w-4" data-id="element-1243" data-mp="2z128ii5hchbb" />
                      </button>
                      <button title="Renew" className="p-1 text-slate-500 hover:text-green-600" data-id="element-1244" data-mp="3czs57woe0ez5">
                        <RefreshCw className="h-4 w-4" data-id="element-1245" data-mp="3m06rozd38048" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-1246" data-mp="3vq9n167olq5q">
        <button className="hover:underline" data-id="element-1247" data-mp="3qr6qyb9oiu9w">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-1248" data-mp="3qszw1m4n96fs">|</span>
        <span className="text-slate-900 font-medium" data-id="element-1249" data-mp="9i0a49eyfewq">1</span>
        <span className="text-slate-400" data-id="element-1250" data-mp="9gffykwjxxze">|</span>
        <button className="hover:underline" data-id="element-1251" data-mp="4krqs5i2l4tw">2</button>
        <span className="text-slate-400" data-id="element-1252" data-mp="o5ifla0ccdk7">|</span>
        <button className="hover:underline" data-id="element-1253" data-mp="o6tjraxp7nbu">3</button>
        <span className="text-slate-400" data-id="element-1254" data-mp="s73ras152lst">|</span>
        <button className="hover:underline" data-id="element-1255" data-mp="s5shobl0ijts">next &gt;&gt;</button>
      </div>
    </div>;
}